/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len, implicit-arrow-linebreak */
import * as React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from '@mui/material';
import { IoIosArrowDown } from 'react-icons/io';
import { AssessmentData, Job } from '../../types';
import AssessmentDetails from '../AssesmentDetails';

interface AssesmentsListProps {
  appliedJobs: Job[];
  assessmentFetching: boolean;
  fetchAssessment: (jobOrderId: string) => Promise<void>;
  assessmentData: AssessmentData | null;
}

function AssesmentsList({
  appliedJobs, fetchAssessment, assessmentData, assessmentFetching,
}: AssesmentsListProps) {
  const [expandedJob, setExpandedJob] = React.useState<string | false>(false);

  const handleAccordionChange = (job: Job) => async (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpandedJob(isExpanded ? job.jobOrderId.toString() : false);
    if (isExpanded) {
      console.log('fetching assessment');
      fetchAssessment(job.jobOrderId.toString());
    }
  };
  const filteredJobs = appliedJobs.filter((job: Job) => job.isAppliedFromWebsite);

  return (
    <div className="mx-auto mt-6 w-full max-w-[80%]">
      {filteredJobs.length > 0 ? filteredJobs.map((job: Job) => (
        <Accordion
          key={job.jobOrderId}
          expanded={expandedJob === job.jobOrderId.toString()}
          onChange={handleAccordionChange(job)}
          sx={{ mb: 2, backgroundColor: '#fafafa' }}
        >
          <AccordionSummary
            expandIcon={<IoIosArrowDown />}
            aria-controls={`${job.jobOrderId}-content`}
            id={`${job.jobOrderId}-header`}
          >
            <div className="flex flex-row justify-between w-full">
              <Typography>
                Job Title:
                {' '}
                {job.jobTitle}
              </Typography>
              {expandedJob === job.jobOrderId.toString() && (
                <Typography className="mr-4">
                  Overall AI Score:
                  {' '}
                  {assessmentData?.feedback_score}
                </Typography>
              )}
            </div>
          </AccordionSummary>
          <AccordionDetails sx={{ mb: 1 }} className="text-left">
            <AssessmentDetails
              assessmentData={assessmentData}
              assessmentFetching={assessmentFetching}
            />
          </AccordionDetails>
        </Accordion>
      )) : <Typography>No jobs applied from website</Typography>}
    </div>
  );
}

export default AssesmentsList;
